import React, {useState, useEffect, useMemo, useLayoutEffect} from 'react';
import {
    validatePhoneNumberLength,
    parsePhoneNumberFromString as parsePhoneNumber,
  } from "libphonenumber-js";
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import config from '../config';
import ErrorIcon from '../assets/SVG/icons/error-icon.svg';
import EyeIconOn from '../assets/SVG/icons/eye-icon-active.svg';
import EyeIconOff from '../assets/SVG/icons/eye-icon.svg';
import EmailIcon from '../assets/SVG/icons/email-icon.svg';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/signup.css';
import TermsAndCondition from './TermsAndCondition';
import countryList from "../enum/countryList.enum";
import { getAffiliateAcById } from '../api';
import useToastify from "../hooks/useToastify";
axios.defaults.withCredentials = true;

function SignUp(props) {
    const { notifyError } = useToastify();
    const params = new URLSearchParams(props.history.location.search);
    const affId = params.get("affId");
    const [showAgreement, setShowAgreement] = useState(false);
    const [privacyPolicyAgreement, setPrivacyPolicyAgreement] = useState(false);
    const [useImagesForTrainning, setUseImagesForTrainning] = useState(false);
    const [consentForMarketing, setConsentForMarketing] = useState(false);
    const [isReady, setReady] = useState(true);
    const [state , setState] = useState({
        email : "",
        password : "",
        confirmPassword: "",
        showPassword: false,
        showConfirmPassword: false,
        fname: "",
        lname: "",
        phoneNumber: {
            code: "",
            number: ""
        },
        street: "",
        stateProvince: "",
        country: "",
        ageAgreed: false
    });
    const [affiliateAccount, setAffiliateAccount] = useState();
    const [phoneCountry, setPhoneCountry] = useState(null);
    const [phoneNumberError, setPhoneNumberError] = useState("");

    const handleChange = (e) => {
        const {id , value} = e.target;
        setState(prevState => ({
            ...prevState,
            [id] : value
        }));
    };

    const handlePhoneChange = (value, country) => {
        const dialCode = country.dialCode;
        setPhoneCountry(country);
        setState(prevState => ({
            ...prevState,
            phoneNumber : {
                code: "+" + dialCode,
                number: value.slice(dialCode.length),
            }
        }));
    };

    const setAgeAgreed = (ageAgreed) => {
      setState((prevState) => ({
        ...prevState,
        ageAgreed
      }));
    };

    const toggleShowPassword = (e) => {
        setState(prevState => ({
            ...prevState,
            showPassword: !state.showPassword
        }));
    }

    const toggleShowConfirmPassword = (e) => {
        setState(prevState => ({
            ...prevState,
            showConfirmPassword: !state.showConfirmPassword
        }));
    }    

    const isValidEmail = useMemo(() => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return state.email.toLowerCase().match(re);
    }, [state.email])

    const isValidPassword = useMemo(() => {
        const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,}$/;
        return state.password.match(re);
    }, [state.password]);

    const isValidPhoneNumber = useMemo(() => {
        if(state.phoneNumber.code && state.phoneNumber.number && phoneCountry) {
            const countryCode = phoneCountry?.countryCode?.toUpperCase();
            const number = state.phoneNumber.code + state.phoneNumber.number;
            const phoneNumber = parsePhoneNumber(number, countryCode);
            const validateLength = validatePhoneNumberLength(number, countryCode);
            if(phoneNumber && phoneNumber.isValid()) {
                setPhoneNumberError("")
                return true
            } else {
                if(validateLength == "TOO_LONG") {
                    setPhoneNumberError("The entered number is too long");
                } else if(validateLength == "TOO_SHORT") {
                    setPhoneNumberError("The entered number is too short");
                } else {
                    setPhoneNumberError("The entered number is invalid");
                }
                
                return false;
            }
        } else {
            return false
        }
    }, [state.phoneNumber.number]);

    const handleSubmitClick = async (e) => {
        e.preventDefault();
        if(
            state.email === "" ||
            state.password === "" ||
            state.confirmPassword === "" ||
            state.fname === "" ||
            state.lname === "" ||
            state.phoneNumber.number === "" ||
            !isValidPhoneNumber ||
            state.stateProvince === "" ||
            state.country === "" ||
            !state.ageAgreed ||
            !isValidEmail ||
            state.password != state.confirmPassword ||
            !isValidPassword
        ) {
            setReady(false);
        } else {
            setShowAgreement(true);
        }
    };

    const sendDetailsToServer = () => {       
        const payload={
            email: state.email.trim().toLowerCase(),
            pw: state.password,
            firstName: state.fname,
            lastName: state.lname,
            phoneNumber: state.phoneNumber,
            agreement: {
                ageAgreed: state.ageAgreed,
                ageAgreedOn: new Date(),
                privacyPolicy: privacyPolicyAgreement,
                privacyPolicyAgreedOn: new Date(),
                useImagesForTrainning,
                useImagesForTrainningAgreedOn: useImagesForTrainning ? new Date(): undefined,
                consentForMarketing,
                consentForMarketingAgreedOn: consentForMarketing ? new Date(): undefined,
            },
            address: {
                // street: state.street,
                stateProvince: state.stateProvince,
                country: state.country,
            },
            affiliateLinkId: affId,
            trialTestLimit: affiliateAccount?.trialTestLimit,
            covidTrialTestLimit: affiliateAccount?.covidTrialTestLimit,
            cardioTrialTestLimit: affiliateAccount?.cardioTrialTestLimit,
            trialDays: affiliateAccount?.trialDays,
        };        

        axios.post(config.backend_url+'/register', payload)
        .then(function (response) {
            if(response.status === 200){
                props.setSignup(true);
                props.history.push({ 
                    pathname: '/verify',
                    search: '?new=true',
                });
            } else{
                setState(prevState => ({
                    ...prevState,
                    failureMessage : response.data.errorMsg
                }));
                notifyError(response.data.errorMsg);
            }
        })
        .catch(function (error) {
            setShowAgreement(false);
            if(error.response) {
                setState(prevState => ({
                    ...prevState,
                    failureMessage : error.response.data.errorMsg
                }));

                error.response.data.errorMsg ? notifyError(error.response.data.errorMsg) : notifyError("Registration Failure!")
            }
            else {
                notifyError("Network Error!");
            }
        });            
    };
    
    useEffect(() => {
        document.title = "Sign up"
    }, []);
    useLayoutEffect(() => {
        if(affId) {
            getAffiliateAcById(affId).then(res => {
                setAffiliateAccount(res.affiliateAccount)
            })
        }
    }, [affId]);

    return (
        <>
            {
                showAgreement ? <TermsAndCondition
                    setShowAgreement={setShowAgreement}
                    sendDetailsToServer={sendDetailsToServer}
                    privacyPolicyAgreement={privacyPolicyAgreement}
                    setPrivacyPolicyAgreement={setPrivacyPolicyAgreement}
                    setUseImagesForTrainning={setUseImagesForTrainning}
                    setConsentForMarketing={setConsentForMarketing}
                    useImagesForTrainning={useImagesForTrainning}
                    consentForMarketing={consentForMarketing}
                /> : 
                <div className="container">
                    <div className="main signup-form" data-testid="signup-form">
                        <p className='heading'>Sign Up</p>
                        <p className="text-center">Create a new account</p>
                        {/* {affiliateAccount && <p className='refered-by-p'> Referred By {affiliateAccount?.name}</p>} */}
                        <div className='wrapper'>
                        <form>
                            <div className="form-group">
                                <label className="label">E-mail *</label>
                                <div className="input-box">
                                    <input data-testid="email" type="email" id="email" className={ "form-control " + (state.email ? "navy-text " : "") + (!isReady && (!state.email || !isValidEmail) ? "red-border " : "")} 
                                        placeholder="e-mail@address.com" value={state.email} onChange={handleChange} required/>
                                    <img src={EmailIcon} alt="email icon" />
                                </div>
                                {!isReady && !state.email ? <p data-testid="nullEmail"><img src={ErrorIcon} alt="emailNull"/>Email is Required!</p> : <></>}
                                {!isReady && state.email && !isValidEmail ? <p data-testid="invalidEmail"><img src={ErrorIcon} alt="errMsgEmail"/>Invalid Email!</p> : <></>}
                            </div>
        
                            <div>
                                <div className='password-container'>
                                    <div className="form-group password">
                                        <label className="label">Password *</label>
                                        <div className="input-box">
                                            <input data-testid="password" type={state.showPassword ? "text" : "password"} id="password" className={ "form-control " + (state.password ? "navy-text " : "") + (!isReady && (!state.password || !isValidPassword) ? "red-border " : "")} 
                                                placeholder="Password" value={state.password} onChange={handleChange} required/>
                                            <img data-testid="toggleShowPassword" src={state.showPassword ? EyeIconOn : EyeIconOff} alt="password icon" className='pointer' onClick={toggleShowPassword}/>
                                        </div>
                                    </div>
                                    <div className="form-group confirm-password">
                                        <label className="label">Confirm Password *</label>
                                        <div className="input-box">
                                            <input data-testid="confirm-password" type={state.showConfirmPassword ? "text" : "password"} id="confirmPassword" className={ "form-control " + (state.confirmPassword ? "navy-text " : "") + (!isReady && (!state.confirmPassword || !isValidPassword) ? "red-border " : "")} 
                                                placeholder="Password" value={state.confirmPassword} onChange={handleChange} required/>
                                            <img data-testid="toggleShowConfirmPassword" src={state.showConfirmPassword ? EyeIconOn : EyeIconOff} alt="confirm password icon" className='pointer' onClick={toggleShowConfirmPassword}/>
                                        </div>
                                    </div>
                                </div>
                                {
                                    !isReady && (
                                        (!state.password || !state.confirmPassword ) ? <p data-testid="isPassNull"><img src={ErrorIcon} alt="passNull"/>Password is Required!</p> :
                                        state.password != state.confirmPassword ? <p data-testid="errMsgPass"><img src={ErrorIcon} alt="errMsgPass"/>Passwords don't match</p> :
                                        !isValidPassword ? <div data-testid="invalidPassword"><p><img src={ErrorIcon} alt="invalidPassword"/>Password should contain: </p>
                                            <ul>
                                                <li>At least 1 uppercase character</li>
                                                <li>At least 1 lowercase character</li>
                                                <li>At least 1 numeric character</li>
                                                <li>At least 1 special character</li>
                                                <li>Length must be at least 8 characters</li>
                                            </ul>
                                        </div> : <></>
                                    )
                                }
                            </div>
        
                            <div className="form-group">
                                <label className="label">First Name *</label>
                                <input data-testid="firstName" type="text" id="fname" className={ "form-control " + (state.fname ? "navy-text " : "") + (!isReady && !state.fname ? "red-border " : "")} 
                                    placeholder="First Name" value={state.fname} onChange={handleChange} required/>
                                {!isReady && !state.fname ? <p data-testid="isFnameNull"><img src={ErrorIcon} alt="fnameNull"/>First Name is Required!</p> : <></>}
                            </div>
        
                            <div className="form-group">
                                <label className="label">Last Name *</label>
                                <input data-testid="lastName" type="text" id="lname" className={ "form-control " + (state.lname ? "navy-text " : "") + (!isReady && !state.lname ? "red-border " : "")} 
                                    placeholder="Last Name" value={state.lname} onChange={handleChange} required/>
                                {!isReady && !state.lname ? <p data-testid="isLnameNull"><img src={ErrorIcon} alt="lnameNull"/>Last Name is Required!</p> : <></>}
                            </div>
                            <div className="form-group">
                                <label className="label">Phone Number *</label>
                                <PhoneInput
                                    data-testid="phoneNumber"
                                    id="phoneNumber"
                                    inputClass={ "form-control " + (state.phoneNumber.number ? "navy-text " : "") + (!isReady && !state.phoneNumber.number ? "red-border " : "")}
                                    buttonClass={(state.phoneNumber.number ? "navy-text " : "") + (!isReady && !state.phoneNumber.number ? "red-border " : "")}
                                    inputProps={{
                                        name: 'phoneNumber',
                                        "data-testid": "phoneNumber",
                                        id: 'phoneNumber',
                                        required: true
                                    }}
                                    country={'ca'}
                                    value={state.phoneNumber.code + state.phoneNumber.number}
                                    onChange={handlePhoneChange}
                                    required
                                />
                                {phoneNumberError && <p data-testid="isPhoneNumberError"><img src={ErrorIcon} alt="phoneNumberError"/>{phoneNumberError}</p>}
                                {!isReady && !state.phoneNumber.number ? <p data-testid="isPhoneNumberNull"><img src={ErrorIcon} alt="phoneNumberNull"/>Phone Number is Required!</p> : <></>}
                            </div>
        
                            <div className='province-country'>
                                <div className="form-group state-province">
                                    <label className="label">Province/State *</label>
                                    <input data-testid="stateProvince" type="text" id="stateProvince" className={ "form-control " + (state.stateProvince ? "navy-text " : "") + (!isReady && !state.stateProvince ? "red-border " : "")} 
                                        placeholder="Ontario" value={state.stateProvince} onChange={handleChange} required/>
                                    {!isReady && !state.stateProvince ? <p data-testid="stateProvinceNull"><img src={ErrorIcon} alt="stateProvinceNull"/>Province/State is Required!</p> : <></>}
                                </div>
                                <div className="form-group select-country">
                                    <label className="label">Country *</label>
                                    <select id="country" name="country" className={"custom-select " + (state.country ? "navy-text " : "") + (!isReady && !state.country ? "red-border " : "")} data-testid="country" onChange={handleChange}>
                                        <option disabled selected >Country</option>
                                        {
                                            countryList.map((country, index) => (<option key={index} value={country}>{country}</option>))
                                        }
                                    </select>
                                    {!isReady && !state.country ? <p data-testid="isCountryNull"><img src={ErrorIcon} alt="isCountryNull"/>Country is Required!</p> : <></>}
                                </div>
                            </div>
        
                            <div className="age-agreement">
                                <input
                                type="checkbox"
                                id="ageAgreed"
                                data-testid="ageAgreed"
                                className="agree-age-checkbox"
                                onChange={() => setAgeAgreed(!state.ageAgreed)}
                                checked={state.ageAgreed}
                                />
                                <div>I certify that I'm at least 18 year old.</div>
                            </div>
                            {!isReady && !state.ageAgreed && (
                                <div data-testid="missing-age-agreement">
                                    <img src={ErrorIcon} alt="lnameNull" />
                                    You must be at least 18 to use this platform.
                                </div>
                            )}
        
        
                            <div className="btn-submit">
                                <button className="agree-button" data-testid="proceed-btn" type="submit" onClick={handleSubmitClick} >Proceed</button>
                            </div>
                        </form>
                        </div>
                        <div className="signin-link">
                            <p>Already have an account? <Link to='/login'><span> Log In</span></Link></p>
                        </div>
                    </div>
                </div>
            }
        </>
        
    )
}

export default withRouter(SignUp);
